export default __webpack_public_path__ + "static/media/angel-up.5b604dd0.svg";